var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDeliveringOrder = function SvgDeliveringOrder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0H2C0.89543 0 0 0.895431 0 2V8C0 9.10457 0.895431 10 2 10H12C13.1046 10 14 9.10457 14 8V2C14 0.89543 13.1046 0 12 0Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0001 11.5V11.8232C12.0001 13.8295 13.1414 15.5692 14.8102 16.4285C14.1878 17.2031 13.6732 18.0678 13.2888 19H12.0001C12.0001 16.2386 9.76153 14 7.00011 14C4.23868 14 2.00011 16.2386 2.0001 19C0.895535 19 -0.0134775 18.098 0.183482 17.0111C0.563626 14.9134 1.51559 12.87 2.85867 11.5H12.0001Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23 12.5C21.8309 12.5 20.7064 12.6911 19.6561 13.0437L19.0001 5.5C19.0001 4.94772 19.4478 4.5 20.0001 4.5C20.5524 4.5 21.0001 4.94772 21.0001 5.5L21.3501 9C26.1023 9.42055 29.9703 12.6709 31.377 16.6685C29.46 14.1361 26.421 12.5 23 12.5Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7 22.5C8.933 22.5 10.5 20.933 10.5 19C10.5 17.067 8.933 15.5 7 15.5C5.067 15.5 3.5 17.067 3.5 19C3.5 20.933 5.067 22.5 7 22.5Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 32C27.9706 32 32 27.9706 32 23C32 18.0294 27.9706 14 23 14C18.0294 14 14 18.0294 14 23C14 27.9706 18.0294 32 23 32ZM27.7404 20.6727C28.1119 20.264 28.0818 19.6316 27.6732 19.2601C27.2645 18.8886 26.6321 18.9187 26.2605 19.3273L21.9049 24.1186L19.6407 22.2318C19.2164 21.8782 18.5858 21.9355 18.2323 22.3598C17.8787 22.7841 17.936 23.4147 18.3603 23.7682L21.3603 26.2682C21.7717 26.6111 22.3802 26.5689 22.7404 26.1727L27.7404 20.6727Z",
    fill: "currentColor"
  })));
};
export default SvgDeliveringOrder;